import { ApiResult, post } from '@/utils/api';
import { ResultModel } from '@/model/viewModel';
import {
  ShopAvailableDateModel,
  ShopConfigModel,
  ShopDetailModel,
  ShopKitchenModel,
} from '@/model/shop';
import { OrderTableListItemModel } from '@/model/order';
import { useAuthStore } from '@/store/auth';
import { resolveAccessibleShopIds } from '@/constants/auth';

export const fetchShopList = async (data: any): Promise<ApiResult<ResultModel<any>>> => {
  const response = await post<ResultModel<any>>('/dim/shop/select', data);
  const accessibleShopIds = resolveAccessibleShopIds(useAuthStore().user?.roles || []);
  if (accessibleShopIds && response.result?.list) {
    response.result.list = response.result.list.filter((shop: ShopDetailModel) =>
      accessibleShopIds.includes(Number(shop.shopId)),
    );
    response.result.total = response.result.list.length;
  }
  return response;
};

export const fetchTableList = (
  data: any,
): Promise<ApiResult<ResultModel<OrderTableListItemModel>>> =>
  post<ResultModel<OrderTableListItemModel>>('/dim/table/select', data);

export const fetchKitchenList = (data: any): Promise<ApiResult<ResultModel<any>>> =>
  post<ResultModel<any>>('/dim/kitchen/select', data);

export const fetchShopKitchenList = (
  data: any,
): Promise<ApiResult<ResultModel<ShopKitchenModel>>> =>
  post<ResultModel<ShopKitchenModel>>('/dim/shop/kitchen/select', data);

export const fetchStoveList = (data: any): Promise<ApiResult<ResultModel<any>>> =>
  post<ResultModel<any>>('/dim/stove/select', data);

export const fetchShopDetail = (data: any): Promise<ApiResult<ShopDetailModel>> =>
  post<ShopDetailModel>('/dim/shop/selectOne', data);

export const getSelfPickTimeList = (data: any): Promise<ApiResult<ShopAvailableDateModel[]>> =>
  post<ShopAvailableDateModel[]>('/dim/shop/selfPickTime', data);

export const getDeliveryTimeList = (data: any): Promise<ApiResult<ShopAvailableDateModel[]>> =>
  post<ShopAvailableDateModel[]>('/dim/shop/deliveryTime', data);

export const getBookTimeList = (data: any): Promise<ApiResult<ShopAvailableDateModel[]>> =>
  post<ShopAvailableDateModel[]>('/dim/shop/bookTime', data);

export const getShopConfigList = (data: any): Promise<ApiResult<ResultModel<ShopConfigModel>>> =>
  post<ResultModel<ShopConfigModel>>('/dim/shop/config/select', data);
